import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoMatPaginatorIntl extends MatPaginatorIntl {
    private transloco = inject(TranslocoService);

    public constructor() {
        super();
        this.transloco
            .selectTranslate(['FIRST_PAGE', 'LAST_PAGE', 'NEXT_PAGE', 'PREVIOUS_PAGE', 'ITEMS_PER_PAGE'])
            .subscribe((t) => {
                this.firstPageLabel = t.FIRST_PAGE;
                this.lastPageLabel = t.LAST_PAGE;
                this.nextPageLabel = t.NEXT_PAGE;
                this.previousPageLabel = t.PREVIOUS_PAGE;
                this.itemsPerPageLabel = t.ITEMS_PER_PAGE;
                this.changes.next();
            });
    }

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }

        length = Math.max(length, 0);

        const startIndex: number = page * pageSize;
        const endIndex: number = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        return `${startIndex + 1} - ${endIndex} / ${length}`;
    };
}
